<template>
	<span class="comment-count-skeleton">
		<SuiSkeleton :animate width="2rem" height="1.5rem" />
		<SuiIcon name="icon-chat-16" />
	</span>
</template>

<script setup lang="ts">
import { SuiIcon, SuiSkeleton } from '@developers/scoro-ui';

withDefaults(
	defineProps<{
		animate?: boolean;
	}>(),
	{
		animate: true,
	}
);
</script>

<style lang="scss">
.comment-count-skeleton {
	--sui-icon-fill: #{$neutral-60};

	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.5rem;
}
</style>
